module["exports"] = [];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/name/prefix.js
// module id = 1765
// module chunks = 0